import type { TaskStatus } from '@cis/shared';
import { STATUS_LABELS } from './format.ts';

export function StatusPill(props: { readonly status: TaskStatus }): React.JSX.Element {
  return <span className={`pill pill--${props.status}`}>{STATUS_LABELS[props.status]}</span>;
}
